module.exports = __webpack_public_path__ + "img/hviezda2.af498526.svg";